/* assets/section-urb-recipes-hub.js */
(function () {
  function norm(s) {
    return (s || '').toLowerCase().replace(/ł/g, 'l').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  function initHub(root) {
    if (!root || root.dataset.urbInit === '1') return;
    root.dataset.urbInit = '1';
    var grid = root.querySelector('[data-rhub-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-rhub-card]'));
    var controls = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var search = root.querySelector('[data-rhub-search]');
    var clearBtn = root.querySelector('[data-rhub-clear]');
    var moreBtn = root.querySelector('[data-rhub-more]');
    var empty = root.querySelector('[data-rhub-empty]');
    var count = root.querySelector('[data-rhub-count]');
    var feed = root.querySelector('[data-rhub-feed]');
    var initial = parseInt(root.getAttribute('data-rhub-initial'), 10) || 12;
    var step = initial;
    var limit = initial;
    var state = { okazja: null, czas: null, trudnosc: null, sprzet: null, q: '' };
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function matches(card) {
      if (state.okazja && card.dataset.okazja.split(' ').indexOf(state.okazja) === -1) return false;
      if (state.sprzet && card.dataset.sprzet.split(' ').indexOf(state.sprzet) === -1) return false;
      if (state.trudnosc && card.dataset.trudnosc !== state.trudnosc) return false;
      if (state.czas && Number(card.dataset.czas || 0) > Number(state.czas)) return false;
      if (state.q && norm(card.dataset.title).indexOf(norm(state.q)) === -1) return false;
      return true;
    }
    function apply() {
      var shown = 0, matched = 0;
      for (var i = 0; i < cards.length; i++) {
        if (matches(cards[i])) {
          matched++;
          if (shown < limit) { cards[i].classList.remove('is-hidden'); shown++; }
          else { cards[i].classList.add('is-hidden'); }
        } else {
          cards[i].classList.add('is-hidden');
        }
      }
      if (count) count.textContent = matched;
      if (empty) empty.hidden = matched !== 0;
      if (moreBtn) moreBtn.hidden = matched <= limit;
      var active = !!(state.okazja || state.czas || state.trudnosc || state.sprzet || state.q);
      if (clearBtn) clearBtn.hidden = !active;
    }
    function setActive(dim, val) {
      state[dim] = state[dim] === val ? null : val;
      controls.forEach(function (c) {
        if (c.getAttribute('data-filter') === dim) {
          c.setAttribute('aria-pressed', state[dim] === c.getAttribute('data-value') ? 'true' : 'false');
        }
      });
      limit = initial;
      apply();
    }
    controls.forEach(function (c) {
      c.addEventListener('click', function () {
        var dim = c.getAttribute('data-filter');
        var val = c.getAttribute('data-value');
        setActive(dim, val);
        if (dim === 'okazja' && feed) {
          feed.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }
      });
    });
    if (search) {
      var t;
      search.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () { state.q = search.value; limit = initial; apply(); }, 120);
      });
    }
    if (moreBtn) {
      moreBtn.addEventListener('click', function () { limit += step; apply(); });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        state = { okazja: null, czas: null, trudnosc: null, sprzet: null, q: '' };
        if (search) search.value = '';
        controls.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        limit = initial;
        apply();
      });
    }
    try {
      var deep = (new URLSearchParams(window.location.search).get('okazja') || '').toLowerCase();
      if (deep) {
        var hit = controls.filter(function (c) {
          return c.getAttribute('data-filter') === 'okazja' && c.getAttribute('data-value') === deep;
        })[0];
        if (hit) { state.okazja = deep; hit.setAttribute('aria-pressed', 'true'); }
      }
    } catch (e) {}
    apply();
  }
  function initAll(ctx) {
    var scope = ctx || document;
    if (scope.classList && scope.classList.contains('urb-rhub')) initHub(scope);
    Array.prototype.forEach.call((scope.querySelectorAll ? scope.querySelectorAll('.urb-rhub') : []), function (r) { initHub(r); });
  }
  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();